export class CrmPipelineApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getColumnDefinitions() {
    return this.#http.get('/api/pipelines/column-definitions');
  }

  async getExpressionDefinitions() {
    return this.#http.get('/api/pipelines/expression-definitions');
  }
}
